var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal',{attrs:{"to":"tooltip"}},[_c('div',{staticClass:"tooltip",class:_vm.cssClass,attrs:{"id":_vm.tooltipId}},[_c('up-arrow'),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }